import React from 'react';

const WatcherIcon = () => (
  <svg width='11' height='14' viewBox='0 0 11 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.599915 11.6222C0.599915 9.06944 2.66935 7 5.22214 7H6.37769C8.93047 7 10.9999 9.06944 10.9999 11.6222C10.9999 12.8986 9.96519 13.9333 8.6888 13.9333H2.91103C1.63464 13.9333 0.599915 12.8986 0.599915 11.6222Z'
      fill='#00FC92'
    />
    <circle cx='5.79993' cy='3.18668' r='3.12' fill='#00FC92' />
  </svg>
);

export default WatcherIcon;
